import { VorschlagAbsatzDto } from "../api/advsortiment/models";

export class VorschlagAbsatzDtoClient implements VorschlagAbsatzDto
{
  absatzEnde: string;
  absatzName?: string;
  absatzStart: string;
  catalogProductNumber?: string;
  datum: string;
  fisMenge: number;
  fisUmsatz: number;
  mcMenge: number;
  mcUmsatz: number;
  mcAnteil: number;


  constructor(dt: VorschlagAbsatzDto)
  {
      this.absatzEnde = dt.absatzEnde;
      this.absatzName = dt.absatzName;
      this.absatzStart = dt.absatzStart;
      this.catalogProductNumber = dt.catalogProductNumber;
      this.datum = dt.datum;
      this.fisMenge = dt.fisMenge ? dt.fisMenge : 0;
      this.fisUmsatz = dt.fisUmsatz ? dt.fisUmsatz : 0;
      this.mcMenge = dt.mcMenge ? dt.mcMenge : 0;
      this.mcUmsatz = dt.mcUmsatz ? dt.mcUmsatz : 0;
      this.mcAnteil = dt.mcAnteil ? dt.mcAnteil : 0;

  }



}
